import { session_pskey } from "@tencent/midas-util"

export class PskeyAccount {
  init(opt) {
    return new Promise((resolve, reject) => {
      if (opt.openid && opt.openkey) {
        let loginState = new session_pskey({
          uin: opt.openid,
          pskey: opt.openkey,
          sessiontype: opt.session_type
        })
        resolve({ loginState: loginState })
      } else {
        reject("无登录态")
      }
    })
  }
}
